import React from 'react';

const spinnerStyles = {
  borderTopColor: '#3498db'
};

interface IProps {
  className?: string;
  message?: string;
  borderTopColor?: string;
  testId?: string;
}

const Spinner = ({
  className,
  message,
  borderTopColor = spinnerStyles.borderTopColor,
  testId = ''
}: IProps) => {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col ${className ?? ''} ${
        !!message ? 'items-center justify-center' : ''
      }`}
    >
      <div
        className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-t-4 border-gray-200 ease-linear"
        style={{ borderTopColor }}
      />
      {!!message && <div className="animate-pulse font-medium">{message}</div>}
    </div>
  );
};

export default Spinner;
